import { render, staticRenderFns } from "./FacturaListCustom.vue?vue&type=template&id=c97ca1e4"
import script from "./FacturaListCustom.vue?vue&type=script&lang=js"
export * from "./FacturaListCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports